<template>
  <div dir="rtl" class="w-full p-4">
    <div
        class="relative w-full rounded-lg p-1.5 bg-slate-900/50 border border-white/10 shadow-[0_18px_60px_rgba(0,0,0,0.45)] backdrop-blur-xl"
        role="tablist"
        aria-label="تب‌های گزارش موجودی"
        @keydown="onKeydown"
    >
      <!-- Slider -->
      <div
          class="absolute top-1.5 bottom-1.5 right-1.5 w-[calc(50%-0.375rem)] rounded-lg bg-gradient-to-l from-fuchsia-500/80 to-indigo-500/70 shadow-[0_10px_30px_rgba(99,102,241,0.35)] transition-transform duration-300 ease-out"
          :style="sliderStyle"
          aria-hidden="true"
      ></div>

      <div class="relative z-10 grid grid-cols-2 gap-1">
        <button
            ref="tab1"
            class="tabBtn"
            :class="active === 'tab1' ? 'tabBtn--active' : 'tabBtn--idle'"
            @click="setActive('tab1')"
            role="tab"
            :id="ids.tab1"
            :aria-selected="active === 'tab1'"
            :aria-controls="ids.panel1"
            :tabindex="active === 'tab1' ? 0 : -1"
            type="button"
        >
          <span class="tabIcon">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8 10L4 11"/>
            </svg>
          </span>
          <span class="tabText">موجودی کل</span>
        </button>

        <button
            ref="tab2"
            class="tabBtn"
            :class="active === 'tab2' ? 'tabBtn--active' : 'tabBtn--idle'"
            @click="setActive('tab2')"
            role="tab"
            :id="ids.tab2"
            :aria-selected="active === 'tab2'"
            :aria-controls="ids.panel2"
            :tabindex="active === 'tab2' ? 0 : -1"
            type="button"
        >
          <span class="tabIcon">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
          </span>
          <span class="tabText">موجودی بر اساس برند</span>
        </button>
      </div>
    </div>

    <!-- Panel -->
    <div
        class=" rounded-lg p-4 md:p-5 border border-white/10 bg-slate-950/40 backdrop-blur-xl shadow-[0_18px_60px_rgba(0,0,0,0.35)]"
        role="tabpanel"
        :id="active === 'tab1' ? ids.panel1 : ids.panel2"
        :aria-labelledby="active === 'tab1' ? ids.tab1 : ids.tab2"
    >
      <keep-alive>
        <component :is="currentComp" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "InventoryReport",
  data() {
    return {
      active: "tab1",
      ids: {
        tab1: "inv-tab-1",
        tab2: "inv-tab-2",
        panel1: "inv-panel-1",
        panel2: "inv-panel-2",
      },
    };
  },
  computed: {
    currentComp() {
      return this.active === "tab1" ? "TabByCurrency" : "TabByBrand";
    },
    // RTL: تب ۱ سمت راست، تب ۲ سمت چپ
    sliderStyle() {
      // tab1 => translateX(0) (روی راست)
      // tab2 => translateX(-100%) (به سمت چپ)
      return this.active === "tab1"
          ? { transform: "translateX(0%)" }
          : { transform: "translateX(-102%)" };
    },
  },
  components: {
    TabByCurrency: () => import("@/modules/report/InventoryReportByCurrency"),
    TabByBrand: () => import("@/modules/report/InventoryReportByBrand"),
  },
  methods: {
    setActive(key) {
      this.active = key;
      this.$nextTick(() => {
        const ref = key === "tab1" ? "tab1" : "tab2";
        const el = this.$refs[ref];
        if (el && el.focus) el.focus();
      });
    },
    onKeydown(e) {
      // برای RTL، راست/چپ رو طبیعی نگه می‌داریم:
      // ArrowRight => می‌ره tab1 (راست)
      // ArrowLeft  => می‌ره tab2 (چپ)
      if (e.key === "ArrowRight") {
        e.preventDefault();
        this.setActive("tab1");
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        this.setActive("tab2");
      }
      if (e.key === "Home") {
        e.preventDefault();
        this.setActive("tab1");
      }
      if (e.key === "End") {
        e.preventDefault();
        this.setActive("tab2");
      }
    },
  },
};
</script>

<style scoped>
/* دکمه‌ها max-width دارن که کش نیان */
.tabBtn{
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;

  width: 100%;
  padding: .7rem .9rem;
  border-radius: 0.1rem;

  border: 1px solid transparent;
  transition: 200ms ease;
  outline: none;
}

.tabBtn--idle{
  color: rgba(148,163,184,1); /* slate-400-ish */
}
.tabBtn--idle:hover{
  color: rgba(226,232,240,0.95);
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.08);
}

.tabBtn--active{
  color: white;
}

.tabIcon{
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.10);
  flex: 0 0 auto;
}

.tabText{
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
